const quicklooks = document.querySelectorAll(".custom-featured-btn");
const images = document.querySelectorAll(".custom-featured-img");

quicklooks.forEach((item) => {
  item.addEventListener("mouseover", (event) => {
    const target = event.target.id.split("-")[2];
    document
      .querySelector(`#img-${target}`)
      .classList.add("custom-featured-img-hover");
  });
  item.addEventListener("mouseout", (event) => {
    const target = event.target.id.split("-")[2];
    document
      .querySelector(`#img-${target}`)
      .classList.remove("custom-featured-img-hover");
  });
});

images.forEach((item) => {
  item.addEventListener("mouseover", (event) => {
    const target = event.target.id.split("-")[1];
    document
      .querySelector(`#quick-add-${target}-submit`)
      .classList.add("custom-featured-btn-hover");
  });
  item.addEventListener("mouseout", (event) => {
    const target = event.target.id.split("-")[1];
    document
      .querySelector(`#quick-add-${target}-submit`)
      .classList.remove("custom-featured-btn-hover");
  });
});
